/*
 * @Date: 2023-10-08 16:35:44
 * @Description: 导出四个主题
 */
import base from "./base";
import chplt from "./chplt";
import cptpp from "./cptpp";
import rcep from "./rcep";
export default { base, chplt, cptpp, rcep };
